import {Injectable} from '@angular/core';
import {fromEvent, Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {AppConfigService} from './config.service';

const DEFAULT_LOCAL_STORAGE_KEY_PREFIX = 'devpool';
const BROWSER_STORAGE_NAME = 'storage';

@Injectable()
export class LocalStorageService {
    private localStorage: Storage;
    private storageEvent$: Observable<StorageEvent>;
    private keyPrefix: string;

    constructor(
        private appConfigService: AppConfigService
    ) {
        this.localStorage = localStorage;
        this.storageEvent$ = fromEvent<StorageEvent>(window, BROWSER_STORAGE_NAME);
        this.keyPrefix = appConfigService.appConfig.localStorageKeyPrefix || DEFAULT_LOCAL_STORAGE_KEY_PREFIX;
    }

    public set(key: string, value: any): void {
        this.localStorage.setItem(this.getFullKey(key), JSON.stringify(value));
    }

    public get(key: string, defaultValue?: any): any {
        const value: string | null = this.localStorage.getItem(this.getFullKey(key));

        return value != null ? JSON.parse(value) : defaultValue;
    }

    public remove(key: string): void {
        this.localStorage.removeItem(this.getFullKey(key));
    }

    public onChange(key: string, isFullKey: boolean = false): Observable<StorageEvent> {
        return this.storageEvent$.pipe(
            filter(event => (
                event.key === (isFullKey ? key : this.getFullKey(key))
                && event.newValue !== event.oldValue
            ))
        );
    }

    public onRemove(key: string, isFullKey: boolean = false): Observable<StorageEvent> {
        return this.storageEvent$.pipe(
            filter(event => (
                event.key === (isFullKey ? key : this.getFullKey(key))
                && event.newValue !== event.oldValue && event.newValue === null
            ))
        );
    }

    private getFullKey(key: string): string {
        return [this.keyPrefix, key].join('/');
    }
}
